export default function toNum(value) {
  return Number(value) || 0
}